import { Endpoint } from "../config";

export type NotificationsEndpointType =
  | "notifications"
  | "markAsRead"
  | "markAllAsRead"
  | "deleteNotification"
  | "notificationSettings"
  | "getNotificationByKey"
  | "updateNotificationConfig";

export const notificationsEndpoints: Record<
  NotificationsEndpointType,
  Endpoint
> = {
  notifications: {
    url: "notifications/?company_name=[company_name]",
  },
  markAsRead: {
    url: "notifications/:id/read/",
  },
  markAllAsRead: {
    url: "notifications/mark-all-read/",
  },
  deleteNotification: {
    url: "notifications/:id/",
  },
  notificationSettings: {
    url: "notifications/settings/?company_name=[company_name]",
  },
  getNotificationByKey: {
    url: "notifications/[notification_key]/?company_name=[company_name]",
  },
  updateNotificationConfig: {
    url: "notifications/[notification_key]/?company_name=[company_name]",
  },
};
